import { render, staticRenderFns } from "./matchSubResult.vue?vue&type=template&id=29ed0942&scoped=true&"
import script from "./matchSubResult.vue?vue&type=script&lang=js&"
export * from "./matchSubResult.vue?vue&type=script&lang=js&"
import style0 from "./matchSubResult.vue?vue&type=style&index=0&id=29ed0942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed0942",
  null
  
)

export default component.exports